import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { useUser } from '../context/UserContext';

const CONTACT_EMAIL = 'connect@transtechsys.com';

export default function SubscriptionRequiredPage() {
  const { currentCompany, hasAccess, subscription } = useUser();

  if (hasAccess) {
    return <Navigate to="/home" replace />;
  }

  const hadTrial = Boolean(subscription?.trial_end_display);
  const title = hadTrial ? 'Trial access has ended' : 'Subscription access is inactive';
  const message = hadTrial
    ? `${currentCompany?.name ? `${currentCompany.name}'s` : 'Your'} trial ended ${subscription.trial_end_display}.`
    : `${currentCompany?.name ? `${currentCompany.name}'s` : 'Your'} access is currently inactive.`;

  return (
    <div className="p-4 sm:p-6 lg:p-8 flex items-center justify-center min-h-screen bg-white">
      <div className="max-w-xl w-full space-y-6 border border-gray-200 rounded-lg shadow-sm p-8">
        <div className="text-center">
          <ExclamationTriangleIcon className="h-12 w-12 text-amber-500 mx-auto mb-3" />
          <h1 className="text-xl font-semibold text-gray-900 mb-1">
            {title}
          </h1>
          <p className="text-sm text-gray-600">
            {message} Contact Ames Connect to activate or update this subscription.
          </p>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-sm space-y-2">
          <div className="flex justify-between gap-4">
            <span className="text-gray-500">Company</span>
            <span className="font-medium text-gray-900">{currentCompany?.name || '—'}</span>
          </div>
          <div className="flex justify-between gap-4">
            <span className="text-gray-500">Access</span>
            <span className="font-medium text-gray-900">Inactive</span>
          </div>
          {subscription?.trial_end_display && (
            <div className="flex justify-between gap-4">
              <span className="text-gray-500">Trial End</span>
              <span className="font-medium text-gray-900">{subscription.trial_end_display}</span>
            </div>
          )}
        </div>

        <p className="text-sm text-gray-600 text-center">
          Email{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} className="font-medium text-red-600 hover:underline">
            {CONTACT_EMAIL}
          </a>{' '}
          for subscription changes.
        </p>
      </div>
    </div>
  );
}
